export default {
    // StripeThankYou.vue
    'An error occured while processing your order': 'Une erreur est survenue lors du traitement de votre commande',
    'Processing your order': 'Traitement de votre commande',
    'Thank you': 'Merci',
    'What\'s next ?': 'Et maintenant ?',
    'Thank you for the purchase': 'Merci pour votre achat',
    'Home': 'Accueil',
    'Download invoice': 'Télécharger la facture',
    'You order is still processing': 'Votre commande est toujours en cours de traitement',
    'View payment status': 'Voir le statut du paiement',
    
    // StripeThankYouError.vue
    'An error occurred while processing your order.': 'Une erreur est survenue lors du traitement de votre commande.',
    'The support team has been notified, but you can also contact them.': 'L\'équipe de support a été notifiée, mais vous pouvez également les contacter.',
    
    // StripeThankYouOk.vue
    'Your order has been successfully processed': 'Votre commande a été traitée avec succès',
    
    // StripeThankYouStillProcessing.vue
    'Your order is still processing, please contact the suport if you have any question.': 'Votre commande est toujours en cours de traitement, veuillez contacter le support si vous avez des questions.',
    
    // TotalDisplay.vue
    'Total amount': 'Montant total',
    'Excluding taxes': 'Hors taxes',
    'All taxes included': 'Toutes taxes comprises',
    'VAT': 'TVA',
    
    // StripeMain.vue
    'Billing Information': 'Informations de facturation',
    'VAT Number': 'Numéro de TVA',
    'Payment details': 'Détails de paiement',
    'By clicking below, you agree to our': 'En cliquant ci-dessous, vous acceptez nos',
    'Terms of Service': 'Conditions d\'utilisation',
    'Privacy Policy': 'Politique de confidentialité',
    'and automatic renewal. You authorize Vodalys to charge': 'et le renouvellement automatique. Vous autorisez Vodalys à facturer',
    'or the then-current rate (plus any tax) each year until you cancel in your account settings.': 'ou le tarif alors en vigueur (taxes en sus) chaque année jusqu\'à ce que vous annuliez dans les paramètres de votre compte.',
    'Your plan will be automatically renewed on': 'Votre abonnement sera automatiquement renouvelé le',
    'At any time, the renew can by canceled.': 'À tout moment, le renouvellement peut être annulé.',
    'and': 'et',
    'Purchase': 'Acheter'
}